import React, { useState } from 'react'
import "./about.css";
import rahul from "../Img/rahul.png"
// import { NavLink } from 'react-router-dom';
const About = () => {

  const [scale, setscale] = useState(90);
  // const [value, setvalue] = useState(); // Start at white


  const handleScroll = () => {

    const minScroll = 10;
    const maxScroll = 500;
    const minScale = 0;
    const maxScale = 90;

    const scrollTop = window.scrollY;

    let scaleValue;
    if (scrollTop <= minScroll) {
      scaleValue = maxScale;
    } else if (scrollTop >= maxScroll) {
      scaleValue = minScale;
    } else {
      const scrollFraction = (scrollTop - minScroll) / (maxScroll - minScroll);
      scaleValue = maxScale - scrollFraction * (maxScale - minScale);
    }

    setscale(Math.floor(scaleValue));


  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <div className='aboutme'>

      {/* <div className='goback'>
        <NavLink to={"/"}>
          <h1>
            H O M E
          </h1>
        </NavLink>
        <NavLink to={"/projects"}>
          <h1>
            PROJECTS
          </h1>
        </NavLink>
        <NavLink to={"/skills"}>
          <h1>
            My Tech.
          </h1>
        </NavLink>
      </div> */}

      <div className='location'>
        <p><span>Location:</span></p>
        <p>Local time GMT</p>
        <p>(+5:30)</p>

      </div>

      <div className='portfolio'>
        <p>PORTFOLIO</p>

      </div>


      <div className='aboutme_box'>
        <div className='details1'>
          <p>
"Masters student at <i className='bold'>IIT Delhi</i> with a foundation in full-stack development and a growing focus on Machine Learning, Deep Learning, and Computer Vision. I build across the stack — from MERN-based web applications to CV algorithms like GMM background subtraction — bridging the gap between research and implementation. Explore my projects and GitHub below to see both sides of my work."          </p>

        </div>
        <div className='details2'>
          <p>
            "Elevating user experiences—one line of code at a time."
          </p>

        </div>

        <h1 className='txt1' style={{ transform: `translateX(${-scale * 2}px)` }}>RAHUL</h1>
        <h1 className='txt2' style={{ transform: `translateX(${scale * 2}px)` }}>BISHNOI </h1>

        <div className='img'>
          <div className='redshade'></div>
          <img className='rahulpic' src={rahul} alt='img'></img>
        </div>

      </div>




    </div>
  )
}

export default About